import { render, staticRenderFns } from "./LocationMessage.vue?vue&type=template&id=2a8f7fed&scoped=true&"
import script from "./LocationMessage.vue?vue&type=script&lang=js&"
export * from "./LocationMessage.vue?vue&type=script&lang=js&"
import style0 from "./LocationMessage.vue?vue&type=style&index=0&id=2a8f7fed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f7fed",
  null
  
)

export default component.exports